/** @import modules */

import { useTranslation }       from "react-i18next";

import { useParams }            from "react-router-dom";

import parse                    from 'html-react-parser';

import { Helmet }               from "react-helmet-async";

import {
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
}                               from "../../Components/SEO/localizedMeta";

/** @import models */

import { SingleServiceModel }   from "../../Models/Services";

/** @import components */

import Breadcrumbs              from "../../Components/Layout/Header/Breadcrumbs";

import Layout                   from "../../Components/Services/Layout";

import ComponentLoader          from "../../Components/Layout/Loaders/Loader";

/**
 * 
 * @returns Services page
 * 
 */

const SingleService = () => { const { t, i18n } = useTranslation (),

    currentLanguage = normalizeLanguage(i18n?.resolvedLanguage || i18n?.language),

    { serviceId } = useParams (),

    { loading, data } = SingleServiceModel (),

    selectedService = ! loading

        ? data.services.edges.find ( obj => obj.node.id === serviceId )?.node

        : null,

    metaDescription = selectedService?.title

        ? localizedValue({
            lv: `${ selectedService.title } Tireshop.lv servisā - profesionāla apkalpošana un ērta pieteikšanās tiešsaistē.`,
            en: `${ selectedService.title } at Tireshop.lv service - professional support and convenient online booking.`,
            ru: `${ selectedService.title } в сервисе Tireshop.lv - профессиональное обслуживание и удобная онлайн-запись.`
        }, currentLanguage)

        : localizedValue({
            lv: "Tireshop.lv autoservisa pakalpojumi - profesionāla apkalpošana un ērta pieteikšanās tiešsaistē.",
            en: "Tireshop.lv car service - professional support and convenient online booking.",
            ru: "Автосервис Tireshop.lv - профессиональное обслуживание и удобная онлайн-запись."
        }, currentLanguage),

    servicePath = selectedService ? `/content/services/${ selectedService.id }` : "/content/services",

    canonicalHref = localizedAbsoluteUrl(servicePath, currentLanguage),

    alternateLinks = hreflangLinks(servicePath);

    /** @return component */

    return ( <div className="container max-content-width">

        <Helmet>

            <title>{ `Tireshop.lv | ${ selectedService?.title || t ( "services" ) }` }</title>

            <meta
                name="description"
                content={ metaDescription }
            />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "services" ), URI: `/${ t ( "__permalink_content__" ) }/${ t ( "__permalink_services__" ) }` },

            { name: loading ? `${ t ( "loading" ) }...` : ( selectedService?.name || t ( "services" ) ), URI: `/${ t ( "__permalink_content__" ) }/${ t ( "__permalink_services__" ) }` }

        ] } type="basic" />

        <Layout title={ t ( "services" ) }>

            <div className="paragraph">

                { loading ? <ComponentLoader /> : parse ( selectedService?.content || "" ) }

            </div>

        </Layout>
        
    </div> );

}

/** @export SingleService */
 
export default SingleService;
